<template>
    <div class="bimg">
      <Row><Col span="24" style="height:700px;">
      <div class="load" >
        <Col span="16" offset="4">
        <br/>
        <h1 style="color: orange">找回密码</h1>
        <br/>
        <Form :rules="rulesReg" :model="modelReg" :ref="modelReg">
          <FormItem prop="mobile">
            <!--<Col span="14" offset="6">-->
              <Input  v-model="modelReg.mobile" placeholder="请输入手机号"></Input>

           <!-- </Col>-->
          </FormItem>
          <FormItem prop="msgValidateCode">
             <Row><Col span="10">
              <Input  v-model="modelReg.msgValidateCode" placeholder="请输入验证码"></Input>
           </Col><Col span="9" offset="3">
              <Button type="warning" @click="setTime(60)" :disabled="btnDisenable">{{btnMsgYzmVal}}</Button>
            </Col></Row>
          </FormItem>
          <FormItem prop="password">
            <!--<Col span="14" offset="6">-->
              <Input  v-model="modelReg.password" placeholder="请设置新密码" type="password"></Input>
            <!--</Col>-->
          </FormItem>
          <FormItem >
            <Col span="10" offset="4">
              <Button type="warning" style="width:180px;" @click="goRePassword(modelReg)">修改密码</Button>
            </Col>
          </FormItem>
        </Form></Col>
        </div>

     </Col></Row>
    </div>
</template>

<script>
    export default {
        name: "index",
      data(){
          return{
             unclick:true,
             modal:false,
             modelReg:{
              mobile:'',
              password:'',
              msgValidateCode:'',
              confirmPwd:''
          }
        ,
          countdown: 60,
          btnDisenable:false,
          timer:null,
        
        btnMsgYzmVal: "获取验证码",
        rulesReg: {
          mobile: [
            { required: true, message: "请输入手机号码", trigger: "blur" },
            {
          
              min: 11,
              max: 11,
              message: "请输入11位有效手机号码",
              trigger: "blur"
            },
            { pattern: /^[0-9]*$/, message: "手机号必须为数字", trigger: "blur" } 
          ],
          password: [
            { required: true, message: "请输入密码", trigger: "blur" },
            {
            
              min: 8,
              max: 20,
              message: "请输入8~20位字母，数字或符号",
              trigger: "blur"
            },
            {
              pattern: /^[0-9a-zA-Z!@#$%^&*]{8,20}$/,
              message: "请输入数字、字母或特殊符号"
            } 
            
          ],
        
          msgValidateCode: [
            { required: true, message: "请输入短信验证码", trigger: "blur" }
          ]
        }  
          }
      },
      methods:{
        goRePassword:function(formName){
          this.$refs[formName].validate((valid)=>{
          if(valid){
              this.loading = true;
              let params = {
                mobile: this.modelReg.mobile,
                pwd: this.modelReg.password,
                rePwd: this.modelReg.password,//md5(this.pwd + this.mobile)
                msgValidateCode:this.modelReg.msgValidateCode
              };
              protocol.param_rePassword.data =params;
              http.post(protocol.param_rePassword).then(response => {
                if (response.data.code == 0) {
                  this.$Message.info(response.data.msg);
                  this.$router.push({ path: "/load" });
                } else {
                  //this.$message({ type: "warning", message: response.data.msg });
                  this.$Message.info(response.data.msg);
                }
              });
          
            }else{
              console.log("errro submit!")
              return false
            }
          })
        },
        setTimeOld(e) {
            let _this = this;
            e--;
            this.btnMsgYzmVal ="重新获取" +e + "s";
            if (e > 0) {
              this.btnDisenable=true;
              setTimeout(function() {
                _this.setTime(e);
              }, 1000);
            } else {
              this.btnMsgYzmVal = "获取验证码";
                this.btnDisenable=false;
            }
          },
        getCode3:function(){
          protocol.param_rePasswordverifyCode.data.mobile =this.modelReg.mobile;
              http.gets(protocol.param_rePasswordverifyCode, protocol.param_rePasswordverifyCode.data).then(response => {
                if (response.data.code == 0) {
                  this.$Message.info(response.data.mCode);
                } else {
                  this.$Message.info(response.data.msg);
                }
          });
        },
        setTime(e){
        this.getCode3();
        this.setTime2(e);
        },
        setTime2(e) {
          let _this = this;
          e--;
          this.btnMsgYzmVal ="重新获取" +e + "s";
          if (e > 0) {
            this.btnDisenable=true;
            setTimeout(function() {
              _this.setTime2(e);
            }, 1000);
          } else {
              this.btnMsgYzmVal = "获取验证码";
              this.btnDisenable=false;
          }
        }
      }
    }
</script>

<style scoped>
  .load{
    width: 400px;
    height: 300px;
      opacity: 0.9;
    background: whitesmoke;
   margin: 200px auto;
  }
.bimg {
 border-bottom:1px solid black;
  opacity: 0.9;
  background-size: cover;
  background-image: url("../../../static/officeImg/index/connectBac1.png");
  
  height: 700px;
  margin:0 auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/password/index.vue